var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.isActiveSnackbar)?_c('SnackbarAlertComponent'):_vm._e(),_c('SnackbarAlertNewComponent'),(_vm.isActiveDialogAlert)?_c('DialogAlertComponent'):_vm._e(),_c('UserConsentComponent'),_c('QiscusAcquisitionAnnouncementComponent'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }